/**
 * API base URL configuration for shared services.
 *
 * In development, both Vite apps proxy /api/* and /socket.io/* to the backend
 * via their vite.config.ts, so we use empty string (relative URLs).
 *
 * In production, set VITE_API_URL to the API domain (e.g., https://api.showliner.io).
 */

let _apiBaseUrl: string | null = null;

export const getApiBaseUrl = (): string => {
  if (_apiBaseUrl !== null) return _apiBaseUrl;

  // Vite env var (set in production builds)
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Default: empty string = relative URLs (Vite proxy handles routing in dev)
  return '';
};

/**
 * Allow apps to configure the base URL programmatically at startup.
 * Call this before any API service is used.
 */
export const setApiBaseUrl = (url: string): void => {
  _apiBaseUrl = url;
};
